var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center p-4 rounded-lg border-2 border-dashed h-64"},[_vm._v(" Tags ")])
}
var staticRenderFns = []

export { render, staticRenderFns }